export const commonPlacement = ['top', 'bottom', 'top-start', 'top-end', 'bottom-start', 'bottom-end', 'right'];
export const tooltipPlacement = [...commonPlacement, 'left'];
export const popperPlacement = [...commonPlacement, 'right-start', 'right-end', 'left', 'left-start', 'left-end'];
/**
 * Default settings for React-Popper. Specify arguments if you need to limit common.
 * @param fallback: Custom fallback placement.
 * @param offset: Custom offset.
 * @param listeners: Scroll and resize listeners. Allows recalculate popover position while scrolling/resizing.
 */
export const popperModifiers = ({
  fallback = popperPlacement,
  offset = [0, 14],
  listeners
}) => [{
  name: 'offset',
  options: {
    offset
  }
}, {
  name: 'flip',
  options: {
    fallbackPlacements: fallback
  }
}, {
  name: 'eventListeners',
  enabled: listeners
}];